import React, { useState } from 'react';
import './freshBanner.css';
import ProductDetailsModal from './ProductDetailsModal';
import FalconDescription from '../FalconDescription/FalconDescription';
import FalconAccordionList from '../FalconAccordionList/FalconAccordionList';
import Spacer from '../Spacer/Spacer';

const FreshProductDetails = ({
  click,
  setClick,
  buttonLabel,
  content,
  priceSection,
  combineWithSmartphone,
  callCart,
  from,
  shoppingCart
}: any) => {
  const [modalState, setModalState] = useState(click);
  let falconBody: any = [],
    backBtn = '';
  const productDetails =
    from == 'linetable' ? content.subscriptionDetailModal : content.productDetails;
  productDetails &&
    productDetails?.length > 0 &&
    productDetails?.map((e: any) => {
      falconBody = e?.modalBody;
      backBtn = e?.backButton;
    });

  const handleClick = () => {
    setModalState(!modalState);
    setClick(!click);
  };

  const buttonClick = () => {
    if (typeof callCart === 'function') callCart();
  };
  return (
    <>
      {click && (
        <ProductDetailsModal
          modalState={modalState}
          handler={handleClick}
          showFooter={false}
          height={'100%'}
          width={'883px'}
          backButton={backBtn}
        >
          {falconBody?.map((ele: any, index: number) => (
            <>
              {ele?.component === 'falconDescription' && (
                <>
                  <FalconDescription content={ele} key={index} /> <br />
                </>
              )}
              {ele?.component === 'spacer' && <Spacer content={ele} />}
              {ele?.component === 'falconAccordionList' && <FalconAccordionList content={ele} />}
            </>
          ))}
          <div className='row justify-content-center'>
            {from === 'linetable' ? (
              <div>{priceSection}</div>
            ) : (
              <div className='productDetailsPriceSection'>
                <div className='priceWrapper'>
                  {priceSection}
                  {content?.checkoutBtn && (
                    <button className='productDetailsProceedToCheckoutButton' onClick={buttonClick}>
                      <span>{content?.checkoutBtn}</span>
                      <img
                        src={shoppingCart?.filename}
                        alt='shopping-cart'
                        height={24}
                        width={24}
                      />
                    </button>
                  )}
                </div>
                <div className='line' />
                {content?.discountLabel && (
                  <div className='durationText'>{content?.discountLabel}</div>
                )}
              </div>
            )}
            {combineWithSmartphone && (
              <div className='productDetailsCombineWithSmartphone'>{combineWithSmartphone}</div>
            )}
          </div>
        </ProductDetailsModal>
      )}
      {buttonLabel && (
        <div onClick={handleClick} className='productDetails'>
          {buttonLabel}
        </div>
      )}
    </>
  );
};

export default FreshProductDetails;
